// Friendlier loading state (AMB-394) — replaces bare "Loading…" lines on the heavier
// screens (digest, knowledge base, transcript, my tasks) with a little bounce + a
// reassurance line, since these fetches can run a handful of seconds.

const LINES = [
  "Hang tight — this can take a few seconds.",
  "Rounding up the details…",
  "Almost there — thanks for your patience.",
];

export function FriendlyLoading({
  message = "Working on it…",
  index = 0,
  className = "",
}: {
  message?: string;
  index?: number;
  className?: string;
}) {
  const sub = LINES[index % LINES.length];
  return (
    <div className={`flex flex-col items-center justify-center gap-2.5 py-16 text-center ${className}`}>
      <div className="flex gap-1">
        {[0, 1, 2].map((i) => (
          <span
            key={i}
            className="h-2 w-2 animate-bounce rounded-full bg-gray-300"
            style={{ animationDelay: `${i * 0.15}s` }}
          />
        ))}
      </div>
      <p className="text-[13px] font-medium text-gray-600">{message}</p>
      <p className="text-[11px] text-gray-400">{sub}</p>
    </div>
  );
}
